import { createSlice } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import { timeCurrent } from "helpers/timestamp"
import { CookieType } from "types"

export const initialState: CookieType = {
  cookie: {
    required: true,
    analytics: true,
    personal: true,
    given: null,
    givenAt: null,
  },
  session: {
    terms: false,
    privacy: false,
    advertisement: false,
    given: null,
    givenAt: null,
  },
}

export const cookieConsentSlice = createSlice({
  name: "consent",
  initialState,
  reducers: {
    updateCookie: (state, { payload }) => {
      state.cookie = {
        ...state.cookie,
        ...payload,
        given: true,
        givenAt: timeCurrent(),
      }
    },
    updateSession: (state, { payload }) => {
      state.session = {
        ...state.session,
        ...payload,
        given: true,
        givenAt: timeCurrent(),
      }
    },
  },
})

export const { updateCookie, updateSession } = cookieConsentSlice.actions

export const selectCookieConsent = (state: RootState) => state.consent

export default cookieConsentSlice.reducer
